var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/component/x-file-change-name-dialog.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "./x-file-list";
import "./x-file-upload.js";
var XFileChangeNameDialog = class extends XNativeDialog {
  static changeName(currentName) {
    return this.showPopup({
      modal: true,
      props: {
        fileName: currentName
      }
    });
  }
  static get element_name() {
    return "x-file-change-name-dialog";
  }
  cancel() {
    this.close(void 0);
  }
  content() {
    return html`
      <x-flex ${css({ gap: "24px", padding: "16px" })}>
        <x-flex
          horizontal
          crossaxis-center
          ${css({
      gap: "8px",
      position: "sticky",
      top: "0px",
      padding: "16px 0",
      background: "#fff",
      zIndex: "999"
    })}
        >
          <x-text flex ${css({ fontSize: "24px" })}> <b> Neuer Dateiname </b> </x-text>
        </x-flex>

        <x-input
          placeholder="Dateiname"
          .value=${this.fileName}
          @value-changed=${(e) => {
      this.fileName = e.detail.value;
    }}
        ></x-input>

        <x-flex
          horizontal
          space-between
          crossaxis-center
          ${css({
      gap: "8px"
    })}
        >
          <x-button
            mode="outline"
            @click=${() => {
      this.cancel();
    }}
          >
            Abbrechen
          </x-button>
          <x-button
            @click=${() => {
      this.close(this.fileName);
    }}
          >
            Speichern
          </x-button>
        </x-flex>
      </x-flex>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        dialog: {
          display: "block",
          width: "min(700px, 90%)",
          boxSizing: "border-box"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false, type: String })
], XFileChangeNameDialog.prototype, "fileName", 2);
XFileChangeNameDialog = __decorateClass([
  customElement("x-file-change-name-dialog")
], XFileChangeNameDialog);
export {
  XFileChangeNameDialog
};
